import T from 'prop-types';
import React from 'react';
import { MachineTypes, useResolutionCheck } from 'web-components';
import { getPlcProtocolName } from 'attrs/plcConfigValues';
import { getValueToNullableCell } from 'helpers/stringHandler';
import { useTranslation } from 'react-i18next';
import MobileMachineTable from '../MobileMachineTable';
import CloneMachineTable from './CloneMachineTable';
import TableInput from '../TableInput/TableInput';

const getMachineTypeName = typeParam => {
  const machineType = MachineTypes.find(({ value }) => value === typeParam);
  return getValueToNullableCell(machineType?.name);
};

const CloneMachineTableSelector = ({ rows, organizationId, setSelectedMachineToClone, selectedMachineToClone }) => {
  const { isTablet } = useResolutionCheck();
  const { t } = useTranslation();

  const columns = [
    {
      id: 'machine_name',
      label: <TableInput name="machine_name" placeholder={t('machines.overview.clone_modal.table.machine_name')} />,
      sortable: false,
      cellRenderer: row => getValueToNullableCell(row?.name)
    },
    {
      id: 'commission_number',
      label: (
        <TableInput name="commission_number" placeholder={t('machines.overview.clone_modal.table.commission_number')} />
      ),
      sortable: true
    },
    {
      id: 'machine_type',
      label: <TableInput name="machine_type" placeholder={t('machines.overview.clone_modal.table.machine_type')} />,
      sortable: false,
      cellRenderer: row => row?.other_type || getMachineTypeName(row?.type)
    },
    {
      id: 'plc_type',
      label: <TableInput name="plc_type" placeholder={t('machines.overview.clone_modal.table.plc_type')} />,
      sortable: false,
      cellRenderer: row => getPlcProtocolName(row?.plc_type, false)
    },
    {
      id: 'customer_name',
      label: <TableInput name="organization_name" placeholder={t('machines.overview.clone_modal.table.custumer')} />,
      sortable: true,
      cellRenderer: row => getValueToNullableCell(row.organization_name)
    }
  ];

  return isTablet ? (
    <MobileMachineTable columns={columns} rows={rows} />
  ) : (
    <CloneMachineTable
      columns={columns}
      rows={rows}
      organizationId={organizationId}
      selectedMachineToClone={selectedMachineToClone}
      setSelectedMachineToClone={setSelectedMachineToClone}
    />
  );
};

CloneMachineTableSelector.propTypes = {
  rows: T.instanceOf(Object).isRequired,
  organizationId: T.string,
  selectedMachineToClone: T.shape({
    id: T.string
  }).isRequired,
  setSelectedMachineToClone: T.func.isRequired
};

CloneMachineTableSelector.defaultProps = {
  organizationId: null
};

export default CloneMachineTableSelector;
